if (!customElements.get('shore-carousel')) {
  class ShoreCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-carousel-track]');
      this.nav = this.querySelector('[data-carousel-nav]');
      this.dots = this.querySelector('[data-carousel-dots]');
      this.prevButton = this.querySelector('[data-carousel-prev]');
      this.nextButton = this.querySelector('[data-carousel-next]');
      if (!this.track) return;

      this.onScroll = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      };
      this.onPrev = () => this.goTo(this.currentPage() - 1);
      this.onNext = () => this.goTo(this.currentPage() + 1);

      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.prevButton?.addEventListener('click', this.onPrev);
      this.nextButton?.addEventListener('click', this.onNext);

      this.resizeObserver = new ResizeObserver(() => this.build());
      this.resizeObserver.observe(this.track);
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.track?.removeEventListener('scroll', this.onScroll);
      this.prevButton?.removeEventListener('click', this.onPrev);
      this.nextButton?.removeEventListener('click', this.onNext);
    }

    pageWidth() {
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      return this.track.clientWidth + gap;
    }

    pageCount() {
      const { scrollWidth, clientWidth } = this.track;
      if (clientWidth === 0) return 1;
      const gap = this.pageWidth() - clientWidth;
      return Math.max(1, Math.ceil((scrollWidth + gap - 2) / this.pageWidth()));
    }

    currentPage() {
      const { scrollLeft, scrollWidth, clientWidth } = this.track;
      if (scrollLeft + clientWidth >= scrollWidth - 2) return this.pageCount() - 1;
      return Math.round(scrollLeft / this.pageWidth());
    }

    goTo(page) {
      const target = Math.min(Math.max(page, 0), this.pageCount() - 1);
      this.track.scrollTo({ left: target * this.pageWidth() });
    }

    build() {
      const count = this.pageCount();
      if (this.nav) this.nav.hidden = count < 2;
      if (this.dots && this.dots.childElementCount !== count) {
        const label = this.dots.dataset.dotLabel || '';
        this.dots.replaceChildren(
          ...Array.from({ length: count }, (_, index) => {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'shore-carousel__dot';
            dot.setAttribute('aria-label', label.replace('__number__', index + 1));
            dot.addEventListener('click', () => this.goTo(index));
            return dot;
          })
        );
      }
      this.update();
    }

    update() {
      const page = this.currentPage();
      const count = this.pageCount();
      this.dots?.querySelectorAll('button').forEach((dot, index) => {
        dot.setAttribute('aria-current', index === page ? 'true' : 'false');
      });
      if (this.prevButton) this.prevButton.disabled = page === 0;
      if (this.nextButton) this.nextButton.disabled = page >= count - 1;
    }
  }

  customElements.define('shore-carousel', ShoreCarousel);
}
